export default __webpack_public_path__ + "static/1-7-0-0-d92241324c931013f8578c1ef3a85688.jpg";